import { render, staticRenderFns } from "./studentInfoCertificationRecord_2.vue?vue&type=template&id=2af9a631&scoped=true"
import script from "./studentInfoCertificationRecord_2.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_2.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_2.vue?vue&type=style&index=0&id=2af9a631&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af9a631",
  null
  
)

export default component.exports